import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=2b3de0d8&scoped=true&"
import script from "./switch.ts?vue&type=script&lang=ts&"
export * from "./switch.ts?vue&type=script&lang=ts&"
import style0 from "./switch.scss?vue&type=style&index=0&id=2b3de0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3de0d8",
  null
  
)

export default component.exports